import { Dialog } from "@base-ui/react/dialog";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Skeleton } from "@circleco/compass/components/Skeleton";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import type { Ref } from "react";

import { t } from "@/i18n-js/instance";

import { MobilePostModalHeader } from "./MobilePostModalHeader";

const ACTION_PLACEHOLDER_COUNT = 5;

interface PostModalHeaderSkeletonProps {
  closeButtonRef?: Ref<HTMLButtonElement>;
}

export const PostModalHeaderSkeleton = ({
  closeButtonRef,
}: PostModalHeaderSkeletonProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobilePostModalHeader
        closeButtonRef={closeButtonRef}
        title={t("post_modal_v4.loading_title")}
        aria-busy="true"
        aria-live="polite"
      >
        <Skeleton className="size-8" />
      </MobilePostModalHeader>
    );
  }

  return (
    <header
      className="flex flex-row items-center gap-4 rounded-t-lg px-6 pt-4"
      aria-busy="true"
      aria-live="polite"
    >
      <Dialog.Title className="sr-only">
        {t("post_modal_v4.loading_title")}
      </Dialog.Title>
      <Skeleton className="h-8 w-2/3" />

      <div className="ml-auto flex items-center gap-1">
        {Array.from({ length: ACTION_PLACEHOLDER_COUNT }).map((_, index) => (
          <Skeleton key={`skeleton-${String(index)}`} className="size-9" />
        ))}
        <Dialog.Close
          ref={closeButtonRef}
          render={
            <IconButton
              variant="ghost"
              size="md"
              icon="cross"
              aria-label={t("post_modal_v4.close")}
            />
          }
        />
      </div>
    </header>
  );
};
